import { render, staticRenderFns } from "./dropdown_text.vue?vue&type=template&id=40d2111a"
import script from "./dropdown_text.vue?vue&type=script&lang=js"
export * from "./dropdown_text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports